export default function NotAllowed(){
    return(
        <>
            <div className="dashboard-content">
                <h1>Not allowed</h1>
                <p>You´re not allowed to view this domain</p>
            </div>
        </>
    )
}